import { Button, useConfirm, useLoading, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Spacer } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { useConsortiumActions } from '../../../../store/consortium/actions';
import {
  customerConsortiumPlanIsSelectedSelector,
  hasCustomerConsortiumChannelsSelectedSelector,
  hasCustomerItemSelected,
} from '../../../../store/consortium/selector';
import { confirmMessageProps } from '../../utils';

interface FooterProps {}

export const Footer: React.FC<FooterProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { confirm } = useConfirm();
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { handleResetCustomerConsortium } = useConsortiumActions();
  const { hide, show } = useLoading();

  const hasCustomerSelected = useRecoilValue(hasCustomerItemSelected);
  const hasCustomerConsortiumChannelsSelected = useRecoilValue(
    hasCustomerConsortiumChannelsSelectedSelector
  );

  const customerConsortiumPlanIsSelected = useRecoilValue(customerConsortiumPlanIsSelectedSelector);

  const cancelButtonIsDisabled = !hasCustomerSelected;
  const sendButtonIsDisabled =
    !hasCustomerSelected ||
    !customerConsortiumPlanIsSelected ||
    !hasCustomerConsortiumChannelsSelected;

  const handleSend = () => {
    show({
      title: 'Aguarde enquanto estamos processando sua recomendação.',
      description: 'Este processo pode levar alguns segundos, não saia desta pagina.',
    });

    setTimeout(() => {
      navigate('ConsortiumSent');
      handleResetCustomerConsortium();
      hide();
    }, 3000);
  };

  const handleCancel = () => {
    confirm({ ...confirmMessageProps, isMobile }, () => {
      handleResetCustomerConsortium();
      navigate('Cockpit');
    });
  };

  if (isMobile) {
    return (
      <Button
        isDisabled={sendButtonIsDisabled}
        _text={{ fontWeight: Typography['fontweight.semibold'] }}
        variant="callToAction"
        onPress={handleSend}>
        Enviar
      </Button>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <Spacer />
      <HStack space={Spacing['inline.xxxs']}>
        <Button
          isDisabled={cancelButtonIsDisabled}
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant="secondary"
          onPress={handleCancel}>
          Cancelar
        </Button>
        <Button
          isDisabled={sendButtonIsDisabled}
          _text={{ fontWeight: Typography['fontweight.semibold'] }}
          variant="callToAction"
          onPress={handleSend}>
          Enviar
        </Button>
      </HStack>
    </HStack>
  );
};
